// store/experienceSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Experience } from '../interfaces/store';
import { testData } from '../interfaces/const';

const initialState: Experience[] = [];
// const initialState: Experience[] = testData

const experienceSlice = createSlice({
  name: 'experiences',
  initialState,
  reducers: {
    addExperience(state, action: PayloadAction<Experience>) {
    const index = state.findIndex(e => e.id === action.payload.id);
    action.payload.status = 'created'
    if (index !== -1) {
        state[index] = action.payload;
    } else {
        state.push(action.payload);
    }
    },
    updateExperience(state, action: PayloadAction<Experience>) {
        // EMPTY BLOCK
    },
    removeExperience(state, action: PayloadAction<string>) {
      const index = state.map(e => e.id).indexOf(action.payload);
      const item = state[index]

      if (item.type === 'work') {
        item.city = ''
        item.company = ''
        item.description = ''
        item.endDate = ''
        item.startDate = ''
        item.id = ''
        item.role = ''
      } else if (item.type === 'internship') {
        item.city = ''
        item.company = ''
        item.description = ''
        item.endDate = ''
        item.startDate = ''
        item.id = ''
        item.institution = ''
        item.role = ''
      } else if (item.type === 'education') {
        item.city = ''
        item.description = ''
        item.endDate = ''
        item.startDate = ''
        item.institution = ''
        item.education = ''
      }

      // item.status= 'delete'
      state[index] = item
      return state
      // return state.filter(e => e.id !== action.payload);
    },
  },
});

export const { addExperience, updateExperience, removeExperience } = experienceSlice.actions;
export default experienceSlice.reducer;
